import type { OrderedExcalidrawElement } from "@excalidraw/element/types";
import type { AppState, BinaryFiles } from "@excalidraw/excalidraw/types";

import type { DrawolaEnvelope } from "./types";

export const ENVELOPE_SCHEMA_VERSION = 1 as const;

export function packEnvelope(args: {
  name: string;
  elements: readonly OrderedExcalidrawElement[];
  appState: Partial<AppState>;
  files: BinaryFiles;
  localDocId?: string;
}): DrawolaEnvelope {
  const now = Date.now();
  const appVersion =
    typeof window !== "undefined" && "__DRAWOLA_SHA__" in window
      ? String((window as any).__DRAWOLA_SHA__)
      : "dev";
  return {
    schemaVersion: 1,
    appVersion,
    localDocId: args.localDocId,
    createdAtClient: now,
    updatedAtClient: now,
    name: args.name,
    scene: {
      type: "excalidraw",
      version: 2,
      source: "drawOla",
      elements: args.elements,
      appState: args.appState,
      files: args.files,
    },
  };
}

export function unpackEnvelope(raw: unknown): DrawolaEnvelope {
  if (!raw || typeof raw !== "object") {
    throw new Error("Invalid envelope: not an object");
  }
  const env = raw as Partial<DrawolaEnvelope>;
  if (env.schemaVersion !== ENVELOPE_SCHEMA_VERSION) {
    throw new Error(`Unsupported envelope schema: ${env.schemaVersion}`);
  }
  if (!env.scene || env.scene.type !== "excalidraw") {
    throw new Error("Invalid envelope: missing scene");
  }
  return env as DrawolaEnvelope;
}
